module.exports = __webpack_public_path__ + "img/img-download-app-store.3ad9d7e.svg";